import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Components
import Toggle from 'react-toggle';
import { ButtonV2, Link } from '@zola/zola-ui';

// Content
import EDIT_PAGES_CONTENT from '../../../../constants/EditPagesContent/EditPagesContent';

// Actions
import { showModal } from '../../../../actions/ModalActions';

const EntityHeader = ({
  page,
  pageTitle,
  pageDek,
  pageInfoBlock,
  pageTipsContent,
  onAdd,
  entityName,
  entityOptions,
  themeKey,
  onPageToggle,
  openTipsModal,
  isGotItTooltip,
  gotItTooltip,
  dataTooltip,
}) => {
  const pageType = page ? page.type : undefined;
  const pageId = page ? page.id : undefined;
  const isPageHidden = page ? page.hidden : undefined;
  const title = pageTitle || EDIT_PAGES_CONTENT[pageType].title;
  const dek = pageDek || EDIT_PAGES_CONTENT[pageType].dek;
  const infoBlock = pageInfoBlock || EDIT_PAGES_CONTENT[pageType].infoBlock;
  const tipsContent = pageTipsContent || EDIT_PAGES_CONTENT[pageType].tips;
  const isHomePage = pageType === 'HOME';
  const checkedIcon = <span className="toggle-label checked">Active</span>;
  const uncheckedIcon = <span className="toggle-label unchecked">Inactive</span>;
  const seeDemoHref = `/wedding/sample-${themeKey}/${isHomePage ? '' : pageType.toLowerCase()}`;

  return (
    <section className={`edit-page__header edit-${pageType.toLowerCase()}__header`}>
      <div className="edit-page__title-section">
        <h1 className="edit-page__title">{title}</h1>
        {!isHomePage && (
          <div
            className={`toggle-page-visibility no-tooltip-on-mobile with-tooltip ${isGotItTooltip ? 'hide-tooltip' : ''}`}
            data-tooltip={dataTooltip}
          >
            <Toggle
              checked={!isPageHidden}
              onChange={() => onPageToggle(pageId)}
              icons={{checked: checkedIcon, unchecked: uncheckedIcon}}
            />
            {(gotItTooltip && isGotItTooltip) && gotItTooltip}
          </div>
        )}
        {tipsContent && (
          <div className="edit-page__tips" onClick={() => openTipsModal(tipsContent)}>
            <i className="tips__icon zolaicon-tips" />
            <span className="tips__text">Tips</span>
          </div>
        )}
      </div>
      <div className="edit-page__intro">{dek}</div>
      {themeKey && (
        <div className="edit-page__see-demo">
          <Link arrow href={seeDemoHref} target="_blank" rel="noopener noreferrer">See Sample Page</Link>
        </div>
      )}
      {infoBlock && (
        <div className="edit-page__info-block">{infoBlock}</div>
      )}
      {entityName && (
        <div className="edit-page__add-entity">
          <ButtonV2 onClick={onAdd}>Add {entityName}</ButtonV2>
        </div>
      )}
      {entityOptions && (
        <div className="edit-page__entity-options">
          {entityOptions}
        </div>
      )}
    </section>
  );
}

EntityHeader.propTypes = {
  page: PropTypes.shape({}).isRequired,
  pageInfoBlock: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  onAdd: PropTypes.func,
  entityName: PropTypes.string,
  entityOptions: PropTypes.element,
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
  openTipsModal: PropTypes.func,
  dataTooltip: PropTypes.string,
  isGotItTooltip: PropTypes.bool,
  gotItTooltip: PropTypes.node,
};

EntityHeader.defaultProps = {
  dataTooltip: 'Control if guests see this page when your website is visible. Set to "Inactive" to hide it. Set to "Active" if you\'re ready to share.',
}

const mapDispatchToProps = dispatch => ({
  openTipsModal: (tips) => {
    dispatch(showModal('TIPS_MODAL', { tipsContent: tips }, { size: 'md' }));
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(EntityHeader);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EntityHeaderV2.jsx